/// <reference path="./index.d.ts" />

export function getBenefits(detailId: number, language: string) {
  return fetch(`/event/app/mainAction/memberInfo.htm?detailId=${detailId}&language=${language}`)
    .then(res => res.json())
    .catch((err) => {
      console.log(err);
    })
}

/**
 * Xman
 *
 * @export
 * @param {*} cb
 */
export function Xman(cb) {
  if (cb) {
    if (window.SCHD_COMS.SCXman) {
      cb(window.SCHD_COMS.SCXman);
    } else if (window.SCHD_COMS && window.SCHD_COMS.use) {
      window.SCHD_COMS.use(['xman'], () => {
        if (window.SCHD_COMS.SCXman) {
          cb(window.SCHD_COMS.SCXman);
        }
      });
    }
  }
}

